import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PublicService } from '../public.service';

@Component({
  selector: 'app-services',
  templateUrl: './services.component.html',
  styleUrls: ['./services.component.scss']
})
export class ServicesComponent implements OnInit {
  loading = false;
  key1 = "active";

  constructor(public publicservice : PublicService, public router: Router) {
    if ( publicservice.logedIn == "false"  || this.publicservice.logedIn == null ) {
      this.router.navigate(['login']);
    }

    
    this.publicservice.location = localStorage.getItem("location")!;
   }

  ngOnInit(): void {
  }

  backmap() {
    this.router.navigate(['get-location']);
  }

  wasteClick() {
    this.key1 = "deactive"
    this.loading = true;
    this.publicservice.choosService().then((r) => {
      if(  r.message ==  "successful"){
        this.loading = false;
        this.router.navigate(['done']);
      }
      
    });
   
  }

}
